import React from 'react';
import { wrapFunctionalComponent } from 'utils/framework';
import { Text, Box } from 'components/ui';
import { colors } from 'style/config';

const ProductViewsCount = props => {
    const {
        peopleViewing,
        thresholdForViews,
        localization,
        formatViewCount,
        setAnalytics,
        lookBackWindowForViews,
        showSessionAIMsg,
        showSocialProofPDP,
        blackBackground
    } = props;
    const hasReachedThreshold = peopleViewing && thresholdForViews && peopleViewing >= thresholdForViews;

    if (hasReachedThreshold) {
        setAnalytics(lookBackWindowForViews);
    }

    if ((!showSessionAIMsg && !showSocialProofPDP) || !peopleViewing || !thresholdForViews || !hasReachedThreshold) {
        return null;
    }

    return (
        <Box
            marginTop={4}
            backgroundColor={colors.black}
            borderRadius={2}
            paddingLeft={2}
            paddingRight={2}
            width='fit-content'
            maxWidth='375px'
            {...((showSocialProofPDP.challengerOne || showSocialProofPDP.challengerTwo) &&
                !blackBackground && { marginTop: 0, paddingLeft: 0, backgroundColor: 'unset' })}
        >
            <Text
                is='p'
                lineHeight='24px'
                fontSize='sm'
                color={colors.white}
                {...((showSocialProofPDP.challengerOne || showSocialProofPDP.challengerTwo) &&
                    !blackBackground && { color: colors.black, lineHeight: 1 })}
            >
                <Text paddingRight={1}>🤩</Text>
                <Text {...(showSocialProofPDP.challengerOne && !showSocialProofPDP.challengerTwo && { fontWeight: 'bold' })}>
                    {localization.popularNow}
                </Text>{' '}
                <strong>{formatViewCount(peopleViewing)}+</strong>{' '}
                {showSocialProofPDP.challengerOne ? localization.recentViews : localization.peopleViewed}
            </Text>
        </Box>
    );
};

export default wrapFunctionalComponent(ProductViewsCount, 'ProductViewsCount');
